import { createFileRoute, redirect } from '@tanstack/react-router'
import { convexQuery } from '@convex-dev/react-query'
import { api } from 'convex/_generated/api'
import type { Id } from 'convex/_generated/dataModel'
import ProjectView from '@/features/projects/views/components/project-view/ProjectView'
import { ProjectErrorBoundary } from '@/features/projects/views/components/project-view/ProjectErrorBoundary'

export const Route = createFileRoute('/_authed/projects/$projectId')({
  loader: async ({ context, params }) => {
    const projectId = params.projectId as Id<'projects'>

    const project = await context.queryClient.ensureQueryData(
      convexQuery(api.diy.projects.getDiyProject, { projectId })
    )

    // Guide-first: template-backed projects render via the public /diy/$slug route,
    // which handles both anon and authed tiers with progress tracking overlaid.
    if (project?.templateSlug) {
      throw redirect({ to: '/diy/$slug', params: { slug: project.templateSlug } })
    }
  },
  component: ProjectDetailRouteWrapper,
})

function ProjectDetailRouteWrapper() {
  const { projectId } = Route.useParams()

  return (
    <ProjectErrorBoundary projectId={projectId}>
      <ProjectView projectId={projectId as Id<'projects'>} />
    </ProjectErrorBoundary>
  )
}
